import React from 'react';
import { Provider } from 'models';
import { Link } from 'react-router-dom';
import { Colors, Text } from 'library';
import ProviderReviews from '../ProviderReviews';
import useGoToProfile from '../actions/goToProfile';
import DefaultProfileImage from 'assets/icons/Profile.svg';

const MiniInternalProviderCard = ({ provider, onGoToProfile }: { provider: Provider; onGoToProfile?: () => void }) => {
    const { getProfilePath, onGoToProfileLinkClicked } = useGoToProfile();
    function getClickableProfileImage() {
        return (
            <Link
                to={getProfilePath(provider, undefined)}
                onClick={() => onGoToProfileLinkClicked(provider, 'Provider Card Click', onGoToProfile)}
            >
                {!!provider.profile_image?.image ? (
                    <div
                        style={{
                            width: 150,
                            height: 150,
                            overflow: 'hidden',
                            backgroundColor: Colors.white,
                            backgroundImage: `url(${provider.profile_image?.image})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            borderRadius: 8,
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0,
                        }}
                    ></div>
                ) : (
                    <DefaultProfileImage
                        style={{
                            width: 150,
                            height: 150,
                            borderRadius: 8,
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0,
                        }}
                    />
                )}
            </Link>
        );
    }

    function getClickableProviderName() {
        return (
            <div
                style={{
                    flexDirection: 'row',
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <Link
                    to={getProfilePath(provider, undefined)}
                    onClick={() => {
                        onGoToProfileLinkClicked(provider, 'Provider Card Click', onGoToProfile);
                    }}
                    style={{ color: Colors.darkNavy, textDecoration: 'underline' }}
                >
                    <Text
                        variant="h1"
                        textStyle={{
                            fontSize: 18,
                            maxWidth: '100%',
                            fontWeight: 900,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {provider.user.first_name} {provider.user.last_name}
                    </Text>
                </Link>
            </div>
        );
    }

    function getProviderAgeText() {
        return (
            <Text variant="body2" color={Colors.darkNavy} textStyle={{ marginTop: 6, marginBottom: 12 }}>
                {!!provider.age ? `${provider.age} years old` : ' '}
            </Text>
        );
    }
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                width: 150,
                margin: 20,
                borderRadius: 20,
                border: provider?.applied ? `3px solid ${Colors.darkNavy}` : `1px solid ${Colors.lightGrey}`,
                boxShadow: '0px 3px 6px #00000029',
                backgroundColor: Colors.white,
            }}
        >
            <>
                <div>
                    {getClickableProfileImage()}
                    <div
                        style={{
                            padding: 20,
                            paddingTop: 10,
                            paddingBottom: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            flexGrow: 1,
                        }}
                    >
                        {getClickableProviderName()}
                        <div
                            style={{
                                flexDirection: 'column',
                                display: 'flex',
                                alignItems: 'center',
                                flexWrap: 'wrap-reverse',
                                justifyContent: 'center',
                                marginTop: 6,
                            }}
                        >
                            <ProviderReviews totalReviews={provider.total_reviews} reviewScore={provider.avg_review} />
                            {getProviderAgeText()}
                        </div>
                    </div>
                </div>
            </>
        </div>
    );
};

export default MiniInternalProviderCard;
